import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import {
  Icon,
  Menu,
  Dropdown,
  Col,
  Input,
  Popover,
  Select,
  Button,
  Badge,
  Modal,
  Tabs,
  message
} from 'antd';
import {
  TabMenuContainer,
  EmptySettingsDetails,
  HelpGuideWrapper,
  LoaderContainer,
  TabMenuHeaderContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  SubTabHeading,
  DropdownDetails,
  NoDataView,
  TabSearchContainer,
  PopoverContainer,
  ClearAll,
  NoteText,
  ModalBody,
  SearchNavWrapper,
} from './../../containers/SidebarMenu/styles';
import EmailPreviewModal from '../../components/Modals/EmailPreviewModal';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { FilterSvg } from '../../components/SidebarMenuIcons';
import { withTranslation } from 'react-i18next';
import Loader from '../../components/Loader';
import EditorElement from './../../components/EditorElement/index';
import CreateComplexMailTemplateModal from '../../components/CreateNewTemplate/CreateComplexMailTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import {
  getTemplateStatus,
} from '../../utils/services/templatesAPI';
import AddTagsModal from '../../components/Modals/AddTagsModal';
import {
  DESIGN_AREA_TEMPLATES_TAB,
  TEMPLATE_LOCKED_BY_MODAL,
} from './../../containers/SidebarMenu/translationValues';
import { EMAIL_TEMPLATE_TAB_DETAILS } from './translationValues';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import { fetchManageTags } from '../../utils/services/complexDocumentsAPI';
import { useArtboardContext, CONTEXT_KEYS, TEMPLATE_TYPE } from '../../context/complexArtboardContext';
import { getAllLanguage } from '../../utils/services/languageApi';
import { getAllBlocksInDocument, removeCurrentBusinessLogics, updateMasterTemplateToDocument } from '../../utils/masterTemplateHelper';
import { BusinessLogic } from '../../context/businessLogicContext';
import { updateEmailBusinessLogic } from '../../utils/services/businessLogicApi';
import { FetchEmailTemplatesBycategory, fetchAllEmailTemplates, getMasterEmailsByCategory, getMasterEmails, getMasterlanguageList } from '../../utils/services/complexEmailAPI';
import { deepCopy } from '../../utils/javascript';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { checkSessionUserAccess, SUPPORT_EMAIL_ID, ENTERPRISE_ENV } from '../../utils/helper';
import { useSessionContext } from '../../context/sessionContext';
import { COMPLEX_EMAIL } from '../../utils/complexDocumentConstants';
import axios from 'axios';

const { Option } = Select;
const { TabPane } = Tabs;
const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB', 'TEMPLATE_LOCKED_BY_MODAL'];

const generateEmailThumbnailUrl = (documentId) => `${URL.DESIGN_SYSTEM_URL}email/thumbnail/${documentId}`;

const ComplexEmailTemplatesTab = props => {
  const {
    isBottom,
    isSelectionMode = false,
    setIsBottom,
    activetabIndex,
    attachmentTemp,
    t,
  } = props;

  const getAddTagSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.TAGS], []);
  const [tags, store] = useDocumentContext(getAddTagSelector, `ComplexEmailTemplatesTab`);

  const [selectedView, setSelectedView] = useState('view-templates');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedMasterVariables, setSelectedMasterVariables] = useState();
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [initialLoader, setInitialLoader] = useState(false);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const { businessLogics, setBusinessLogics } = useContext(BusinessLogic);
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);
  const [previousView, setPreviousView] = useState('view-templates');
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [searchedTemplates, setSearchedTemplates] = useState({});
  const [noData, setNodata] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterOption, setFilterOption] = useState('All');
  const [lockedBy, setLockedBy] = useState({});
  const [tagList, setTagList] = useState('');
  const [replaceModalVisibility, setReplaceModalVisibility] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [selectedTab, setSelectedTab] = useState('MyDesigns');
  const [selectedLanguages, setSelectedLangues] = useState(undefined);
  const [languageOption, setLanguageOption] = useState('All');
  const [fetchingLanguage, setFetchingLanguage] = useState(true);
  const [categoryTemplates, setCategoryTemplates] = useState([]);
  const [documentLimit, setDocumentLimit] = useState(null);
  const [planName, setPlanName] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const [templateType, settemplateType] = useState(
    checkSessionUserAccess(userDetails, 'master') ? 'mastertemplate' : 'usertemplate',
  );

  let history = useHistory();
  const cancelTokenRef = useRef();
  const isMasterTab = selectedTab === 'Master';

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign] = useArtboardContext(getCurrentDesign);

  const updateCategoryTemplates = (templates, updationType) => {
    switch (updationType) {
      case 'saveAllCategoryTemplates':
        setCategoryTemplates(templates);
        break;
      case 'addNewTemplateCategory':
        setCategoryTemplates(categoryTemplates => [...categoryTemplates, templates]);
        break;
      case 'updateTemplateCategory':
        if (templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.id === templates.id,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            newCategoryTemplatesList[categoryIndex].name = templates.name;
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }
        break;
      case 'deleteTemplateCategory':
        if (templates.id) {
          const copiedCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
          const updatedCategoryTemplatesList = copiedCategoryTemplatesList.filter(category => {
            return category.id !== templates.id;
          });
          setCategoryTemplates(updatedCategoryTemplatesList);
        }
        break;
      case 'deleteCategoryTemplate':
        if (templates && templates.categoryId && templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.categoryId === templates.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            const categoryTemplatesList = categoryTemplates[categoryIndex].templates;
            const updatedCategoryTemplatesList = categoryTemplatesList.filter(template => {
              return template.id !== templates.id;
            });
            if (categoryTemplates[categoryIndex].templates) {
              newCategoryTemplatesList[categoryIndex].templates = updatedCategoryTemplatesList;
            }
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }
        break;
      case 'saveCategoryTemplate':
        if (templates.categoryDetails && templates.categoryDetails.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.categoryId === templates.categoryDetails.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            newCategoryTemplatesList[categoryIndex].templates.push(templates.savedTemplate);
            setCategoryTemplates(newCategoryTemplatesList);
          } else {
            let newCategory = templates.categoryDetails;
            newCategory.templates = [];
            newCategory.templates.push(templates.savedTemplate);
            setCategoryTemplates(categoryTemplates => [...categoryTemplates, newCategory]);
          }
        }
        break;
      case 'updateTemplatePages':
        let { categoryDetails, savedTemplate } = templates;
        const { categoryId, pages, id } = categoryDetails;
        if (categoryId && id && pages.length > 0) {
          const categoryIndex = categoryTemplates.findIndex(
            category => category.categoryId === categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = categoryTemplates[categoryIndex].templates.findIndex(
              templateDetails => templateDetails.id === id,
            );
            if (templateIndex >= 0) {
              let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].name =
                savedTemplate.name;
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].pages = pages;
              setCategoryTemplates(newCategoryTemplatesList);
            }
          } else {
            let newCategory = categoryDetails;
            newCategory.templates = [];
            newCategory.templates.push(savedTemplate);
            setCategoryTemplates(categoryTemplates => [...categoryTemplates, newCategory]);
          }
        }
        break;

      case 'updateTemplateTags':
        if (templates.categoryId && templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            category => category.categoryId === templates.categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = categoryTemplates[categoryIndex].templates?.findIndex(
              templateDetails => templateDetails.id === templates.id,
            );
            if (templateIndex >= 0) {
              let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].tags =
                templates.tags;
              setCategoryTemplates(newCategoryTemplatesList);
            }
          } else {
            return 0;
          }
        }
        break;

      case 'appendTemplatesToCategory':
        if (templates) {
          const { categoryId, page, allTemplates } = templates;
          let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
          if (categoryId && allTemplates.length > 0) {
            const categoryIndex = categoryTemplates.findIndex(
              categoryDetails => categoryDetails.categoryId === categoryId,
            );
            if (page === 1) {
              newCategoryTemplatesList[categoryIndex].templates = allTemplates;
            } else {
              newCategoryTemplatesList[categoryIndex].templates.push(...allTemplates);
            }
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }
        break;
      case 'emptyTemplate':
        setCategoryTemplates([]);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    (async () => {
      await myDesignFilterOption()
    })();
    // eslint-disable-next-line
  }, [templateType, isSelectionMode]);

  useEffect(() => {
    if (isBottom && !loadMore && !noData) {
      if (selectedView === 'view-search-template') {
        onSearch();
      }
    }
    setDefaultTemplates(categoryTemplates);
    // eslint-disable-next-line
  }, [isBottom, categoryTemplates, templateType]);

  const onScroll = e => {
    if (!setIsBottom) return;
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (Math.abs(scrollTop + clientHeight - scrollHeight) < 10) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  };

  const handleMasterTemplateSelection = async templateObj => {
    try {
      const payload = { draftEmailId: templateObj.id };
      const response = await getMasterEmails(payload);
      if (response?.data?.length) {
        const masterResponse = response.data[0];
        const variables = masterResponse.variables;
        const masterTemplate = masterResponse.documentDTO;
        setSelectedMasterVariables(variables);
        setSelectedTemplate(masterTemplate);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const updateSelectedView = (view, templateObj, action = undefined) => {
    if (view === 'view-templates') {
      setSearchKey('');
      setFilterOption('All');
      setLanguageOption('All')
      setSelectedCategory(undefined);
      setSearchedTemplates({});
      updateCategoryTemplates(defaultTemplates, 'saveAllCategoryTemplates');
    }
    if (action) {
      setPreviousView(action);
    }
    setSelectedView(view);
    if (templateObj && selectedTab === 'Master') {
      handleMasterTemplateSelection(templateObj);
    } else {
      setSelectedTemplate(templateObj);
    }
  };

  useEffect(() => {
    if (selectedAction === "open_addTag_modal") {
      setSelectedAction("add-tag");
    }
  }, [selectedAction])

  const enableModalVisibility = async (actionType, template) => {
    setSelectedTemplate(template);
    if (actionType === 'replace-template') {
      setReplaceModalVisibility(true);
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);

    if (actionType === "add-tag") {
      const payload = { id: template.id, type: 'email' }
      const fetchTagsResponse = await fetchManageTags(payload);
      if (fetchTagsResponse?.statusCode === 1901) {
        setTagList(fetchTagsResponse.data.tags);
        setSelectedAction("open_addTag_modal");
      }
      else {
        message.error(t(DESIGN_AREA_TEMPLATES_TAB.FETCHING_RECORDS_ERROR_MESSAGE.key, DESIGN_AREA_TEMPLATES_TAB.FETCHING_RECORDS_ERROR_MESSAGE.value))
      }
    }
  };

  const handleCreateTemplate = async () => {

    if (ENTERPRISE_ENV || checkSessionUserAccess(userDetails, 'master')) {
      enableModalVisibility('create-template', null);
      return;
    }
    try {
      const response = await fetchPlanUsageDetails();
      if (response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        if (created >= limit) {
          setDocumentLimit(limit);
          setPlanName(planName);
          setShowUpgradeModal(true);
        } else {
          enableModalVisibility('create-template', null);
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  const previewModalVisibility = (e, actionType, template, pageId) => {
    e.stopPropagation();
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const redirectToTemplate = async (template, actionType, updates) => {
    if (template?.id) {
      history.push(`/complexEmailDesign/${template.id}`);
    }
    else {
      history.push(`/complexEmailDesign/${template.templateId}`);
    }
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const onSuccessDeletion = () => {
    setSelectedView('view-templates');
    setUpdateModalVisibility(false);
    myDesignFilterOption();
  };

  const onSearch = async (first = false, category = selectedCategory, searchParam = searchKey, languages = selectedLanguages) => {
    setInitialLoader(true);
    let currentPage = page;
    if (first) {
      setPage(1);
      currentPage = 1;
      setNodata(false);
      setFetchingCategories(true);
    }
    const payload = {
      includeFlows: true,
    };
    if (searchParam !== '') {
      payload.searchParam = searchParam;
    }
    if (category?.categoryId) {
      payload.categoryId = category?.categoryId;
    }
    if (languages?.code) {
      payload.languages = languages?.code;
    }

    setSelectedView('view-search-template');
    setLoadMore(true);
    const response = selectedTab === 'Master' ? await getMasterEmails(payload) : await fetchAllEmailTemplates(payload);
    if (response?.data) {
      const templates = response.data;
      let updatedSearchTemplates = {
        count: response.dataCount,
        templates: first ? templates : [...searchedTemplates?.templates, ...templates],
      };
      setSearchedTemplates(updatedSearchTemplates);
      if (payload.limit * currentPage >= response.dataCount) {
        setNodata(true);
      }
      setPage(currentPage + 1);
    }
    setFetchingCategories(false);
    setLoadMore(false);
    setInitialLoader(false);
  };

  const seeAllByCategory = (category, language) => {
    if (category === 'All' && language === 'All') {
      updateSelectedView('view-templates', null);
    } else {
      setSelectedCategory(category);
      setSelectedLangues(language)
      onSearch(true, category, searchKey, language);
    }
  };

  const onClose = () => {
    setSearchKey('');
    if (!selectedCategory) {
      updateSelectedView('view-templates', null);
    } else {
      onSearch(true, undefined, '');
    }
  };

  const onSuccessAddition = success => {
    if (success && (searchKey.length > 0 || selectedCategory)) {
      onSearch(true);
    }
    setUpdateModalVisibility(false);
  };

  const renderLoader = (styles = {}) => (
    <LoaderContainer top={styles.top}>
      <Loader />
      <div className="loading-txt">
        {t(
          DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.key,
          DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.value,
        )}
      </div>
    </LoaderContainer>
  );

  const renderSearchBar = () => {
    return (
      <TabSearchContainer
        marginTop
        Master={checkSessionUserAccess(userDetails, 'master')}
        inverted={isSelectionMode ? 1 : 0}
      >
        <Input
          name="templateSearch"
          placeholder={t(
            DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.key,
            DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.value,
          )}
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={() => onSearch(true)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {searchKey.length > 0 && <Icon type="close" onClick={onClose} />}
              <Popover
                placement="bottomRight"
                title={t(
                  DESIGN_AREA_TEMPLATES_TAB.FILTER_POPUP_LABEL.key,
                  DESIGN_AREA_TEMPLATES_TAB.FILTER_POPUP_LABEL.value,
                )}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => setFilterVisible(!filterVisible)}
                content={
                  <PopoverContainer>
                    <ClearAll
                      onClick={() => [
                        setFilterVisible(false),
                        updateSelectedView('view-templates', null),
                      ]}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.key,
                        DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.value,
                      )}
                    </ClearAll>

                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.key,
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.value,
                      )}
                    </div>
                    <Select
                      loading={fetchingCategories}
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {defaultTemplates && defaultTemplates?.length > 0 &&
                        defaultTemplates.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>

                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_LANGUAGE_LABEL.key,
                        DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_LANGUAGE_LABEL.value,
                      )}</div>
                    <Select
                      loading={fetchingLanguage}
                      showSearch
                      value={JSON.stringify(languageOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setLanguageOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key,
                          DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {languageList.length > 0 &&
                        languageList.map(data => (
                          <Option key={data.code} value={JSON.stringify(data)}>
                            {data.name}
                          </Option>
                        ))}
                    </Select>

                    <Button
                      type="primary"
                      onClick={() => [setFilterVisible(false), seeAllByCategory(filterOption, languageOption)]}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.key,
                        DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.value,
                      )}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot count={selectedCategory ? null : 0}>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>
            </>
          }
        />
        {!fetchingCategories && selectedView === 'view-search-template' && (
          <NoteText>
            {t(
              DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.key,
              DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.value,
              { templatesCount: searchedTemplates?.count },
            )}
          </NoteText>
        )}
      </TabSearchContainer>
    );
  };

  const renderEmptyView = () => (
    <EmptySettingsDetails inverted={isSelectionMode ? 1 : 0}>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
      <div className="empty-txt">
        <span>
          {t(
            DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.key,
            DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.value,
          ) +
            `${isSelectionMode
                ? ''
                : t(DESIGN_AREA_TEMPLATES_TAB.CLICK.key, DESIGN_AREA_TEMPLATES_TAB.CLICK.value)
            }`}
        </span>
        {!isSelectionMode && (
          <>
            <span
              className="empty-links"
              onClick={handleCreateTemplate}
            >
              {t(DESIGN_AREA_TEMPLATES_TAB.HERE.key, DESIGN_AREA_TEMPLATES_TAB.HERE.value)}
            </span>
            <span>
              {t(
                DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.key,
                DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.value,
              )}
            </span>
          </>
        )}
      </div>
    </EmptySettingsDetails>
  );

  const tabHeaderView = category => {
    return (
      <Col className={checkSessionUserAccess(userDetails, 'master') && 'masterTemplate'}>
        <TabMenuHeader
          inverted={isSelectionMode ? 1 : 0}
          className={attachmentTemp ? 'attachmentTemp' : 'categoryName'}
        >
          <h2>{category.categoryName}</h2>
        </TabMenuHeader>
        {category.templates && category.templates.length >= 4 && (
          <TabMenuHeader
            inverted={isSelectionMode ? 1 : 0}
            onClick={() => seeAllByCategory(category)}
          >
            <div className="see-all">
              {t(
                DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.key,
                DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.value,
              )}
            </div>
          </TabMenuHeader>
        )}
      </Col>
    );
  };

  const renderDropDown = templateObj => {
    return (
      <DropdownDetails
        id={`${templateObj.id}-template`}
        className="dropdown-menu"
        onClick={e => e.stopPropagation()}
      >
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="1"
                onClick={() => enableModalVisibility('delete-template', templateObj)}
              >
                {t(
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key,
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value,
                )}
              </Menu.Item>
              <Menu.Item
                key="2"
                onClick={() => enableModalVisibility('add-tag', templateObj)}
              >
                {t(
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key,
                  DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value,
                )}
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}
          getPopupContainer={() => document.getElementById(`${templateObj.id}-template`)}
        >
          <Icon type="more" />
        </Dropdown>
      </DropdownDetails>
    );
  };

  const singleTemplate = (category, templateObj, action) => {
    let categoryByTemplate = {
      id: templateObj.id,
      name: templateObj.name,
      categoryName: category?.categoryName,
      categoryId: category?.categoryId,
      tags: templateObj.tags,
      targetTemplate: templateObj.flows[0],
    };

    let pageDetails = {
      ...templateObj,
      thumbnail: templateObj?.thumbnail
        ? templateObj?.thumbnail
        : generateEmailThumbnailUrl(categoryByTemplate.id),
      elementDetails: categoryByTemplate,
      isTemplate: true,
      name: templateObj.name,
      id: categoryByTemplate.id,
      ...(templateObj?.style && { style: templateObj.style }),
      ...(templateObj?.variableContract && {
        variableContract: templateObj.variableContract,
      }),
      isMasterTemplate: isMasterTab
    };
    return (
      <EditorElement
        element={pageDetails}
        setIsDragAndDropped={() => {}}
        clickElement={() => {}}
        toggleDragging={() => {}}
        type={COMPLEX_EMAIL}
        cardType={'reusableTemplate'}
        renderDropDown={() => isMasterTab ? () => {} : renderDropDown(categoryByTemplate)}
        onPreviewClick={e => previewModalVisibility(e, 'preview-thumbnail', templateObj, 0)}
        languageList={languageList}
        isMasterTab={isMasterTab}
      />
    );
  };

  const templateCardView = (category, action) => {
    const templateList = category?.templates || category?.documents
    return templateList.length > 0 ? (
      <TabMenuItemContainer>
        {templateList.map(templateObj => {
          return singleTemplate(category, templateObj, action);
        })}
      </TabMenuItemContainer>
    ) : (
      <div></div>
    );
  };

  const renderCategory = () => {
    return (
      <>
        {categoryTemplates.map(category => (
          <TabMenuHeaderContainer key={category.categoryId} firstElement>
            {tabHeaderView(category)}
            {templateCardView(category, 'view-templates')}
          </TabMenuHeaderContainer>
        ))}
      </>
    );
  };

  const handleBusinessLogic = async blockIdsMap => {
    const currentStore = store.get();
    const blBlocks = getAllBlocksInDocument(selectedTemplate.flows);
    const newlyAddedBusinessLogics = [];
    if (selectedTemplate?.businessLogics?.length) {
      for (let i = 0; i < selectedTemplate.businessLogics.length; i++) {
        const businessLogic = selectedTemplate.businessLogics[i];
        businessLogic.documentId = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID];
        businessLogic.id = null;
        businessLogic.rules = businessLogic.rules.map(rule => {
          rule.id = null;
          const origUuid = blBlocks.find(oBlock => oBlock.blockId?.includes(rule.blockId))?.uuid;
          if (origUuid) {
            rule.blockId =
              currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][blockIdsMap.get(origUuid)];
          }
          return rule;
        });
        try {
          const response = await updateEmailBusinessLogic(businessLogic);
          if (response?.data) {
            newlyAddedBusinessLogics.push(response.data);
          }
        } catch (e) {
          console.error(e);
        }
      }
      if (newlyAddedBusinessLogics.length) {
        setBusinessLogics(newlyAddedBusinessLogics);
      }
    }
  };

  const replaceTemplateDetails = async () => {
    const currentStore = store.get();
    const flowUUID = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS][0];
    const blocksIdsMap = new Map();
    if (selectedTab === 'Master') {
      updateMasterTemplateToDocument(store, selectedTemplate.id, '', 'emailTemplate').then(
        async ({ flows, handleBusinessLogic }) => {
          store.setPage('replaceBlocks', {
            uuid: flowUUID,
            blocks: flows[0].blocks,
            style: currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.STYLES],
            flowStyle: flows[0].style,
            blocksIdsMap: blocksIdsMap,
          });
          // delete all business logics and replace it with business logics from master template
          removeCurrentBusinessLogics(businessLogics, setBusinessLogics, true);
          setTimeout(() => {
            handleBusinessLogic && handleBusinessLogic(blocksIdsMap, setBusinessLogics, true);
          }, 1500);
        },
      );
    } else {
      const flows = deepCopy(selectedTemplate.flows);
      store.setPage('replaceBlocks', {
        uuid: flowUUID,
        blocks: flows[0].blocks,
        style: currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.STYLES],
        flowStyle: flows[0].style,
        blocksIdsMap: blocksIdsMap,
      });
      // delete all business logics and replace it with business logics from my design template
      removeCurrentBusinessLogics(businessLogics, setBusinessLogics, true);
      setTimeout(() => {
        handleBusinessLogic(blocksIdsMap);
      }, 1500);
    }
  };

  // this component renders template pages
  const renderTemplates = () => {
    return (
      <div>
        <SubTabHeading Master={checkSessionUserAccess(userDetails, 'master')} className="with-icon">
          <Icon type="left" onClick={() => updateSelectedView(previousView, null)} />
          <div className="subtab-name">{selectedTemplate.name}</div>
          {(checkSessionUserAccess(userDetails, 'client')
            ? selectedTemplate.type === 'usertemplate'
              ? true
              : false
            : selectedTemplate.type === 'mastertemplate'
            ? true
            : false) && (
            <DropdownDetails
              id={`${selectedTemplate.id}-template`}
              className="dropdown-menu dropdown-visible"
              onClick={e => e.stopPropagation()}
            >
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="0" onClick={() => redirectToTemplate(selectedTemplate)}>
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.key,
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    <Menu.Item
                      key="1"
                      onClick={() => enableModalVisibility('delete-template', selectedTemplate)}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key,
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      onClick={() => enableModalVisibility('add-tag', selectedTemplate)}
                    >
                      {t(
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key,
                        DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
                getPopupContainer={() => document.getElementById(`${selectedTemplate.id}-template`)}
              >
                <Icon type="more" />
              </Dropdown>
            </DropdownDetails>
          )}
        </SubTabHeading>
        {selectedTemplate && selectedTemplate.flows?.length > 0 ? (
          <EditorElement
            element={selectedTemplate}
            clickElement={() => { }}
            toggleDragging={() => { }}
            pageSettings={{}}
            setIsDragAndDropped={() => { }}
            type={"replaceFlow"}
            cardType={COMPLEX_EMAIL}
            masterVariables={selectedMasterVariables}
          />
        ) : (
          <div></div>
        )}
      </div>
    );
  };

  const showMoreView = text => {
    const loaderStyles = { top: '0px' };
    return (
      <>
        {loadMore && renderLoader(loaderStyles)}
        {noData && <NoDataView small>{text}</NoDataView>}
      </>
    );
  };

  const renderSearchView = () => {
    return searchedTemplates.templates?.length > 0 ? (
      <>
        <TabMenuItemContainer>
          {searchedTemplates.templates.map(data => {
            const categoryDetails = {
              categoryId: data.categoryId,
              ...data.documentDTO
            };
            return singleTemplate(categoryDetails, selectedTab === 'Master' ? data.documentDTO : data, 'view-search-template');
          })}
        </TabMenuItemContainer>
        {showMoreView(
          t(
            DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.key,
            DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.value,
          ),
        )}
      </>
    ) : (
      <NoDataView>
        {t(
          DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.key,
          DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.value,
        )}
      </NoDataView>
    );
  };

  const renderTabBody = () => {
    switch (selectedView) {
      case 'view-templates':
        return renderCategory();
      case 'view-template-pages':
        return selectedTemplate && renderTemplates();
      case 'view-search-template':
        return renderSearchView();
      default:
        break;
    }
  };

  const AddTagSuccess = (tagsList) => {
    store.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.TAGS]: tagsList });
  }


  const renderModals = () => {
    switch (selectedAction) {
      case 'create-template':
        return (
          <CreateComplexMailTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            onSucess={redirectToTemplate}
            categoryType="template"
          />
        );
      case 'delete-template':
        return (
          <DeleteTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            categoryType="template"
            onSucess={onSuccessDeletion}
            isMailTemplate={true}
            complexEmailTemplate={true}
          />
        );

      case 'add-tag':
        return (
          <AddTagsModal
            visible={updateModalVisibility}
            onCancel={success => onSuccessAddition(success)}
            target={{ id: selectedTemplate.id, elementType: 'email', tags: tagList }}
            isEmail={false}
            isElement={false}
            isComplex={true}
            onSuccess={(tags) => AddTagSuccess(tags)}
          />
        );

      case 'preview-thumbnail':
        return (
          <EmailPreviewModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            type={'document'}
            templateId={selectedTemplate.id}
            templateData={isMasterTab ? undefined : selectedTemplate}
            isMasterTemplate={isMasterTab}
          />
        );
      case 'replace-template':
        return (
          <Modal
            title={t(EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_TITLE.key, EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_TITLE.value)}
            centered
            visible={replaceModalVisibility}
            width="625px"
            onCancel={() => setReplaceModalVisibility(false)}
            footer={[
              <Button key="back" onClick={() => setReplaceModalVisibility(false)}>
                {t(EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_NO_BUTTON.key, EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_NO_BUTTON.value)}
              </Button>,
              <Button key="submit" type="primary" onClick={() => {
                  setReplaceModalVisibility(false);
                  replaceTemplateDetails(selectedTemplate);
              }}>
                {t(EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_YES_BUTTON.key, EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_TEMPLATE_YES_BUTTON.value)}
              </Button>,
            ]}
            className="warning-modal"
          >
            <ModalBody>
              <div className="warning-text">
                <span>{t(EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE.key, EMAIL_TEMPLATE_TAB_DETAILS.REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE.value)}?</span>
              </div>
            </ModalBody>
          </Modal>
        );
      case 'template-locked':
        return (
          <Modal
            title={t(
              `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.key}`,
              TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.value,
            )}
            centered
            width="875px"
            visible={true}
            onCancel={() => setUpdateModalVisibility(false)}
            footer={[
              <Button key="back" onClick={() => setUpdateModalVisibility(false)}>
                {t(
                  `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.key}`,
                  TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.value,
                )}
              </Button>,
              <Button key="submit" type="primary" onClick={() => setUpdateModalVisibility(false)}>
                {t(
                  `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.key}`,
                  TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.value,
                )}
              </Button>,
            ]}
          >
            <ModalBody>
              <div className="warning-text">
                <span>
                  {' '}
                  {t(
                    `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.key}`,
                    TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.value,
                  )}{' '}
                </span>
                {lockedBy && (
                  <>
                    <span>
                      {t(
                        `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.key}`,
                        TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.value,
                      )}
                    </span>{' '}
                    <span className="text-highlighter"> {lockedBy.displayName}</span>
                    <span>
                      {' '}
                      {t(
                        `TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.key}`,
                        TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.value,
                        { templateName: lockedBy.displayName },
                      )}{' '}
                    </span>
                  </>
                )}
              </div>
            </ModalBody>
          </Modal>
        );
      default:
        break;
    }
  };

  const masterFilterOption = async () => {
    const cancelTokenSource = axios.CancelToken.source();
    cancelTokenRef.current = cancelTokenSource;

    setInitialLoader(true);
    setFetchingLanguage(true);
    setFetchingCategories(true);
    
    try {
      const languageListResponse = await getMasterlanguageList();
      if (languageListResponse?.statusCode === 109 && languageListResponse?.data) {
        setLanguageList(languageListResponse.data);
      }
    } finally {
      setFetchingLanguage(false);
    };


    try {
      const DocumentByCategoryResponse = await getMasterEmailsByCategory(cancelTokenSource);
      if (DocumentByCategoryResponse?.statusCode === 707 && DocumentByCategoryResponse?.data) {
        setDefaultTemplates(DocumentByCategoryResponse.data);
        updateCategoryTemplates(DocumentByCategoryResponse.data, 'saveAllCategoryTemplates');
      }
    } finally {
      setFetchingCategories(false);
      setInitialLoader(false);
      cancelTokenRef.current = undefined;
    };
  };

  const myDesignFilterOption = async () => {
    const cancelTokenSource = axios.CancelToken.source();
    cancelTokenRef.current = cancelTokenSource;
    
    setInitialLoader(true);
    setFetchingLanguage(true);
    setFetchingCategories(true);

    try {
      const payload = {
        countPerCategory: 4,
        includeFlows: true,
      };
      const response = await FetchEmailTemplatesBycategory(payload,cancelTokenSource);
      if (response && response?.data) {
        setDefaultTemplates(response.data);
        updateCategoryTemplates(response.data, 'saveAllCategoryTemplates');
      }
    } finally {
      setFetchingLanguage(false);
    };

    try {
      const languageListResponse = await getAllLanguage();
      if (languageListResponse?.statusCode === 109) {
        setLanguageList(languageListResponse.data);
      }
    } finally {
      setFetchingCategories(false);
      setInitialLoader(false);
      cancelTokenRef.current = undefined;
    };
  };

  const selectDesignTabs = key => {
    if(cancelTokenRef.current){
      cancelTokenRef.current.cancel('Operation canceled.');
    };
    updateCategoryTemplates('', 'emptyTemplate');
    if (key === 'Master') {
      masterFilterOption();
    } else {
      myDesignFilterOption();
    }
    setSelectedView('view-templates');
    setSelectedTab(key);
    setFilterOption('All');
    setLanguageOption('All');
    setSearchKey('');
  };

  return (
    <TabMenuContainer
      style={
        isSelectionMode
          ? { marginBottom: 0, position: 'relative' }
          : {
            marginTop:
              selectedView === 'view-templates'
                ? '42px'
                : '125px',
            }
      }
      className={attachmentTemp && 'attachmentTemp'}   >


      {!isSelectionMode && (
        <SearchNavWrapper className={activetabIndex === 0 ? 'showSearch' : 'hideSearch'}>
          {
            CurrentDesign === TEMPLATE_TYPE.DOCUMENT &&
            <Tabs defaultActiveKey="MyDesigns" onChange={selectDesignTabs}>
              <TabPane tab={t(
                  DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TABS_TITLE.key,
                  DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TABS_TITLE.value,
              )} key="MyDesigns"></TabPane>
              <TabPane tab={t(
                  DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TABS_TITLE.key,
                  DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TABS_TITLE.value,
              )} key="Master"></TabPane>
            </Tabs>
          }
          {!initialLoader && <>{renderSearchBar()}</>}
        </SearchNavWrapper>
      )}
      {isSelectionMode && renderSearchBar()}
      {initialLoader && renderLoader()}
      <div>
        {!fetchingCategories && !initialLoader && (
          <div className={isSelectionMode ? 'categoryContainer' : ''} onScroll={onScroll}>
            {categoryTemplates?.length === 0 && renderEmptyView()}
            {categoryTemplates?.length > 0 && renderTabBody()}
          </div>
        )}
      </div>
      {!isSelectionMode && (
        <HelpGuideWrapper>
          <div className="help-container">
            <div
              className="help-action-btn"
              onClick={handleCreateTemplate}
            >
              <Icon type="plus" />{' '}
              {t(
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.key,
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.value,
              )}
            </div>
          </div>
        </HelpGuideWrapper>
      )}
      {!fetchingCategories && updateModalVisibility && selectedAction && renderModals()}
      <UpgradePlanModal
        visible={showUpgradeModal}
        modalText={
          planName === 'Premium' ?
            t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
            : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
              : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
        }
        onCancel={() => setShowUpgradeModal(false)}
      />
    </TabMenuContainer>
  );
};

export default withTranslation(NAMESPACES)(ComplexEmailTemplatesTab);